import { init } from './init'
import { sanitizeData, sanitizeExpire } from './Sanitize'

const actionTypes = {
  FETCH_LOGON: 'FETCH_FREEZE',
  RESET: 'RESET',
}

const fetchReset = async state => {
  state = {
    ...state,
    isLoading: false,
    isStatus: true,
    expireToken: false,
    data: false,
  }
  return state
}

const fetchLogon = async (state, freeze) => {
  state = {
    ...state,
    isStatus: freeze.status,
    expireToken: sanitizeExpire({
      status: freeze.status,
      data: freeze.data,
      name: 'freezeobj',
    }),
    data: sanitizeData({
      status: freeze.status,
      data: freeze.data,
      name: 'freezeobj',
    }),
  }
  return state
}

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.FETCH_FREEZE:
      return fetchLogon(state, action.freeze)
    case actionTypes.RESET:
      return fetchReset(state)
    default:
      return state
  }
}

const freeze = {
  init,
  actionTypes,
  reducer,
}

export default freeze
